/**
 * Composer field chrome — `border-input` for WCAG 1.4.11 UI contrast.
 * Package `RichTextEditor` defaults to `border-control-3`; override via
 * `COMPOSER_RICH_TEXT_EDITOR_SHELL_CLASS`. A solid surface, so the builder's dot
 * canvas does not show through the text.
 */
export const COMPOSER_RICH_TEXT_EDITOR_SHELL_CLASS =
  "border-input bg-background dark:bg-input-background"
